export default __webpack_public_path__ + "static/media/howard_kapiloff_modal.977f34d0.jpg";